const AU_TFN_EXEMPTION_TYPES = {
  applied_for_tfn: {
    desc: 'Applied for TFN',
  },
  under_18_low_income: {
    desc: 'Under 18 and earning below threshold',
  },
  receiving_pension_benefit: {
    desc: 'Receiving pension, benefit or allowance',
  },
} as const;

export default AU_TFN_EXEMPTION_TYPES;
